/**
 * Helper for reading search-service feature flags.
 *
 * On every page load `index.js` fetches the authoritative settings from the
 * backend and writes them to **both** `sessionStorage` (current session) and
 * `localStorage` (cross-tab default).
 *
 * When OpenSearch fails at runtime, the error-fallback code writes `'false'`
 * to **`sessionStorage` only** — so the fallback is scoped to the current
 * session / tab and does not pollute other tabs.
 *
 * Reading order:
 *   1. `sessionStorage`  – has runtime overrides (e.g. error fallback)
 *   2. `localStorage`    – cross-tab default seeded by the last successful
 *                          settings fetch (covers the "open in new tab"
 *                          scenario where `sessionStorage` is empty)
 *
 * @param {string} key  One of the `*_search_enable` keys
 *   (`order_search_enable`, `account_search_enable`, `vpc_search_enable`,
 *    `dns_search_enable`, `four_wheels_search_enable`).
 * @returns {boolean} `true` when the OpenSearch backend should be used.
 */
export function isSearchEnabled(key) {
  return (sessionStorage.getItem(key) ?? localStorage.getItem(key)) === 'true';
}
